export const SET_SNAPSHOT = 'Editor/Snapshots/SET_SNAPSHOT';
export const SET_SNAPSHOT_LOADED = 'Editor/Snapshots/SET_SNAPSHOT_LOADED';
